import isSmimeResponseDisabled from './isSmimeResponseDisabled';
import { confirm } from 'owa-confirm-dialog';
import loc, { format } from 'owa-localize';
import { irm_actionNotAllowedOnThisConversation } from 'owa-locstrings/lib/strings/irm_actionnotallowedonthisconversation.locstring.json';
import { ClientItem, mailStore } from 'owa-mail-store';

/**
 * @param itemId itemId of the itemPart in conversation for which we are responding.
 * @param itemActionString actionString eg. Reply/Forward/Reply All
 */
export const allowResponseForSmimeConversation = (
    itemId: string,
    itemActionString: string
): boolean => {
    const item: ClientItem = mailStore.items.get(itemId);

    if (!isSmimeResponseDisabled(item, true /* isConversationItemPart */)) {
        return true;
    }

    // TODO: WI: 57193 - strings needs to be changed, since S/MIME reply/replyAll/forward not allowed in conversation view
    // if p7m attachment exists.
    const messageString = format(loc(irm_actionNotAllowedOnThisConversation), itemActionString);
    confirm(null /* title */, messageString, false /* resolveImmediately */, {
        hideCancelButton: true,
    });

    return false;
};

export default allowResponseForSmimeConversation;
